'use strict';

angular.module('cgmemApp')
  .controller('PricingReportCtrl', function ($rootScope, AppConfig) {
	this.loading = true;
	this.inputDate1 = moment().format('MM/DD/YYYY');
	this.inputDate2 = moment().subtract(1,'y').format('MM/DD/YYYY');

	AppConfig
		.get()
		.then(appConfig => {
			this.products = appConfig.products;
			this.loading = false;
		});

	this.price = (p, d) => {
		if(!d) return;
		var m = moment.tz(d, 'MM/DD/YYYY',  "America/New_York");

		var validPriceRec = _.find(p.price, function(pr) {
			var s = moment.tz(pr.startDate, 'MM/DD/YYYY',  "America/New_York");
			var e = moment.tz(pr.endDate, 'MM/DD/YYYY',  "America/New_York").add(1,'d');
			return(m.isSameOrAfter(s) && m.isBefore(e));
		});
		return validPriceRec && validPriceRec.price;
	}
  })
  .controller('RosterReportCtrl', function ($rootScope, $http) {
	this.loading = true;
	this.data = [];

	$http.get('/api/reports/teamrosters')
	.then (r => {
		this.data = _.groupBy(r.data, 'product.productName');
	})
	.catch(err => $rootScope.$emit('generalAlert','Error get roster: '+err.statusText))
	.finally( () => this.loading = false);
  })
  .controller('TshirtReportCtrl', function ($rootScope, $http) {
	this.loading = true;
	this.data = [];

	$http.get('/api/reports/tshirts')
	.then (r => {
		this.data = r.data;
	})
	.catch(err => $rootScope.$emit('generalAlert','Error get roster: '+err.statusText))
	.finally( () => this.loading = false);
  })
  .controller('TicketsReportCtrl', function ($rootScope, $q, $http, AppConfig) {
	this.loading = true;
	this.appConfig = {};

	this.productName = function(code) {
		var match = this.appConfig.products.find( function (p) { return p.productCode === code});
		return match && match.productName;
	}

	$q.all([
		AppConfig.get(),
		$http.get('/api/reports/productsaledetail', {params: {productcode: "^SWIM_DIVE_BANQUET"}}),
		$http.get('/api/reports/productsaledetail', {params: {productcode: "^CRAB_FEAST"}})
	])
	.then (r => {
		this.appConfig = r[0];
		this.banquetData = r[1].data;
		this.crabData = r[2].data;
	})
	.catch(err => $rootScope.$emit('generalAlert','Error getting product report: '+err.statusText))
	.finally( () => this.loading = false);
  });
  
